import { Button, Dialog, Stack } from '@etg/wings';
import type { ChangeEvent } from 'react';
import { useState } from 'react';
import { useTranslation } from '@eti/providers';
import { routes } from '../../../../constants/routesAndApisConstants';
import AddonOrdersRadioGroup from '../overview/payment/AddonOrdersRadioGroup';
import { useOrderDetails } from '../../containers/OrderDetailsContext';

interface ReceiptDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
}
const ReceiptDialog = ({ isOpen, onDismiss }: ReceiptDialogProps) => {
  const { t } = useTranslation();
  const { addOnOrders, orderNumber, purchaseDate } = useOrderDetails();
  const [selectedOrder, setSelectedOrder] = useState(orderNumber);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedOrder(event.target.value);
  };

  const orderChangeNumberParam =
    selectedOrder !== orderNumber ? `?orderChangeNumber=${selectedOrder.split('-')[1]}` : '';

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="receipt-dialog"
      isOpen={isOpen}
      onDismiss={onDismiss}
      title={t('OrderDetails.Receipt.Dialog.Heading')}
    >
      <Stack spacing={24}>
        <AddonOrdersRadioGroup
          addOnOrders={addOnOrders}
          dataTestIdPrefix="receipt"
          onChange={handleOnChange}
          orderNumber={orderNumber}
          purchaseDate={purchaseDate}
          selectedValue={selectedOrder}
        />
        <Button
          aria-label={`${t('OrderDetails.Receipt.Dialog.Button')}, ${t(
            'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
          )}`}
          as="a"
          data-testid="receipt-dialog-button"
          href={`${routes.RECEIPT_PDF}${orderChangeNumberParam}`}
          rel="noreferrer"
          target="_blank"
          type="submit"
          variant="primary"
        >
          {t('OrderDetails.Receipt.Dialog.Button')}
        </Button>
      </Stack>
    </Dialog>
  );
};

export default ReceiptDialog;
